import { render, staticRenderFns } from "./budget-requests.vue?vue&type=template&id=66d907cd&scoped=true&"
import script from "./budget-requests.vue?vue&type=script&lang=js&"
export * from "./budget-requests.vue?vue&type=script&lang=js&"
import style0 from "./budget-requests.vue?vue&type=style&index=0&id=66d907cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d907cd",
  null
  
)

export default component.exports